/**
 * @desc 异常调拨提交保存
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  params: API.fulfilment.inPlanMaster.abnormalTransfersSave.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/inPlanMaster/abnormalTransfersSave`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
